import { apis } from "../constants";
import { request } from "../utils";

export const getAlarms = (parmas: Partial<OnlineDataParams>) => {
    return request<AlarmRecord[]>(apis.getAlarms, {
        method: 'post', data: parmas
    })
}
export const getRealtimeDatas = (parmas: Partial<OnlineDataParams>) => {
    return request<RealtimeData[]>(apis.getRealtimeDatas, {
        method: 'post', data: parmas
    })
}

export const searchHistoryLogs = (parmas: Partial<SearchLogParams>) => {
    return request<PagedData<RealtimeData>>(apis.getHistoryLogs, {
        method: 'post', data: parmas
    })
}
export const searchHistoryAlarms = (parmas: Partial<SearchLogParams>) => {
    return request<PagedData<AlarmRecord>>(apis.getHistoryAlarms, {
        method: 'post', data: parmas
    })
}

export const getAlarmTypes  = () => {
    return request<any[]>(apis.getAlarmTypes, {
        method: 'get',
    })
}

export const getDefaultProject = () => {
    return request<{projectId: number, projectName: string}>(apis.getDefaultProject, {
        method: 'get',
    })
}